import React, { useContext, useEffect } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";
import { setShowSpeechBubble } from "core/AssetDownload/Context/actions";

// components
import DrawerRevealSlide from "./DrawerRevealSlide";
import OpeningText from "./OpeningText";
import CopyAttributionWidget from "../CopyAttributionWidget";

const AttributionDesktop = () => {
    const { state, dispatch } = useContext(AssetDownloadContext);

    const {
        attribution: { isCopied, isRequired, isVisible }
    } = state;

    useEffect(() => {
        if (isCopied) {
            dispatch(setShowSpeechBubble(true));
        }
    }, [isCopied]);

    if (!isRequired) {
        return null;
    }

    return (
        <DrawerRevealSlide isVisible={isVisible}>
            <OpeningText />
            <CopyAttributionWidget isDesktop />
        </DrawerRevealSlide>
    );
};

export default AttributionDesktop;
